import CentraliniyRayon from './coordinates/Volgograd/Centraliniy rayon.json';
import VoroshilovskiyRayon from './coordinates/Volgograd/Voroshilovskiy rayon.json';
import KrasnooktyabriskiyRayon from './coordinates/Volgograd/Krasnooktyabriskiy rayon.json';
import DzerzhinskiyRayon from './coordinates/Volgograd/Dzerzhinskiy rayon.json';
import Gumrak from './coordinates/Volgograd/Gumrak.json';
import TraktorozavodskiyRayon from './coordinates/Volgograd/Traktorozavodskiy rayon.json';
import SovetskiyRayon from './coordinates/Volgograd/Sovetskiy rayon.json';
import KirovskiyRayon from './coordinates/Volgograd/Kirovskiy rayon.json';
import Volzhskiy from './coordinates/Volgograd/Volzhskiy.json';

export default {
    regionCode: 'volgograd',
    serviceAreas: [
        {
            id: 'volgograd-1',
            include: [
                {
                    name: 'Тракторозаводский район',
                    type: 'polygon',
                    coordinates: TraktorozavodskiyRayon,
                },
                {
                    name: 'Центральный район',
                    type: 'polygon',
                    coordinates: CentraliniyRayon,
                },
                {
                    name: 'Ворошиловский район',
                    type: 'polygon',
                    coordinates: VoroshilovskiyRayon,
                },
                {
                    name: 'Краснооктябрьский район',
                    type: 'polygon',
                    coordinates: KrasnooktyabriskiyRayon,
                },
                {
                    name: 'Дзержинский район',
                    type: 'polygon',
                    coordinates: DzerzhinskiyRayon,
                },
                {
                    name: 'Советский район',
                    type: 'polygon',
                    coordinates: SovetskiyRayon,
                },
                {
                    name: 'Кировский район',
                    type: 'polygon',
                    coordinates: KirovskiyRayon,
                },
                {
                    name: 'п. Гумрак',
                    type: 'polygon',
                    coordinates: Gumrak,
                },
                {
                    name: 'г. Волжский',
                    type: 'polygon',
                    coordinates: Volzhskiy,
                }
            ]
        },
    ],
};
